/*
 ** This is auto-generated file, don't update/edit this file manually
 ** Please run `yarn update-bm-tokens` to update the content of this file
 */
export const BMPrimitives = {
    BMColor: {
        neutral1: '#ffffff',
        neutral2: '#f0f1f2',
        neutral3: '#c1c4c6',
        neutral4: '#a2a6a8',
        neutral5: '#707577',
        neutral6: '#4f5254',
        neutral7: '#242628',
        neutral8: '#0b0b0b',
        blue0: '#fafcff',
        blue1: '#f5fbff',
        blue2: '#d1f0ff',
        blue3: '#91d6fd',
        blue4: '#0a9af2',
        blue5: '#0071ce',
        blue6: '#024590',
        blue7: '#05285d',
        blue8: '#0e1014',
        banana4: '#ffc629',
        banana5: '#d19e05',
        lime0: '#fdfff5',
        grape4: '#993ff3',
        lime1: '#f7fcde',
        lime2: '#ddfeb4',
        lime3: '#baf075',
        lime4: '#8be200',
        lime5: '#029d24',
        lime6: '#0a5c2c',
        lime7: '#062814',
        orange1: '#fef9dc',
        orange2: '#fff1ce',
        orange3: '#ffcf9d',
        orange4: '#fd5d1c',
        orange5: '#d33e09',
        orange6: '#732b06',
        orange7: '#371406',
        berry1: '#fef5fc',
        cocktailHighAltitude: '#30c5f7',
        cocktailGoodNight: '#235d9f',
        cocktailSpeedLine: '#fca000',
        cocktailBusinessSuit: '#073e68',
        cocktailTerminalLounge: '#6dd3ce',
        cocktailGoldCoin: '#e1cb37',
        cocktailWrapPaper: '#ff474e',
        cocktailFuelTank: '#087e8b',
        cocktailSignalPulse: '#f0298a',
        cocktailFuchsiaFusion: '#931682',
        cocktailCoralReef: '#ff6d6a',
        cocktailShieldProtector: '#3b44ab',
        cocktailFieldTrip: '#20bf55',
        cocktailDreamyVoyage: '#794ee6',
        berry2: '#ffded6',
        berry3: '#fa9eb4',
        berry4: '#ff4581',
        berry5: '#d32d55',
        berry6: '#8b1842',
        berry7: '#3e0923',
    },
    BMRadius: {
        sm: 4,
        md: 10,
        lg: 20,
        rounded: 999,
    },
    BMSize: {
        xs: 4,
        sm: 8,
        md: 12,
        lg: 16,
        xl: 24,
        xl2: 32,
        xl3: 40,
        xl4: 48,
        xl5: 64,
        xl6: 72,
    },
    BMStroke: {
        sm: 1,
        md: 1.5,
        lg: 3,
    },
    BMOpacity: {
        seethrough: 10,
        washed: 40,
        obscure: 60,
    },
    BMBrand: {
        primaryLight: '#91d6fd',
        primary: '#0a9af2',
        primaryDark: '#0071ce',
        accentLightest: '#f7fcde',
        accentLight: '#baf075',
        accent: '#8be200',
        accentDark: '#029d24',
        accentDarkest: '#062814',
        actionRadius: 999,
        productFlights: '#30c5f7',
        productHotels: '#235d9f',
        productTrains: '#fca000',
        productFinancialServices: '#073e68',
        productAirportTransport: '#6dd3ce',
        productLoyaltyPoints: '#e1cb37',
        productGifts: '#ff474e',
        productCars: '#087e8b',
        productPulseData: '#f0298a',
        productFlightHotels: '#931682',
        productTravelActivities: '#ff6d6a',
        productInsurances: '#3b44ab',
        productBus: '#20bf55',
        productPackage: '#794ee6',
    },
};
export const BMComponents = {
    light: {
        BMStyleTextInkPrimary: '#242628',
        BMStyleTextInkPrimaryInvert: '#f0f1f2',
        BMStyleTextInkSecondary: '#707577',
        BMStyleTextInkSecondaryInvert: '#a2a6a8',
        BMStyleTextInkSecondaryOncolorbg: '#0b0b0b99',
        BMStyleTextInkSecondaryOncolorbgInvert: '#ffffff99',
        BMStyleTextInkAction: '#0071ce',
        BMStyleTextInkPrice: '#fd5d1c',
        BMStyleTextInkHighlight: '#029d24',
        BMStyleSurfaceBgcolor: '#ffffff',
        BMStyleSurfaceBgcolorInventory: '#fafcff',
        BMStyleSurfaceBgcolorHero: '#0071ce',
        BMStyleSurfaceBgcolorHighlight: '#fdfff5',
        BMStyleSurfaceBgcolorActive: '#d1f0ff',
        BMStyleSurfaceBgcolorInvert: '#0b0b0b',
        BMStyleSurfaceBgcolorWarning: '#fff1ce',
        BMStyleSurfaceBgcolorError: '#fa9eb4',
        BMStyleSurfaceBgcolorDisabled: '#f0f1f2',
        BMStyleLineBordercolorSubtle: '#f0f1f2',
        BMStyleLineBordercolorBold: '#c1c4c6',
        BMStyleLineBordercolorSubtleInvert: '#242628',
        BMStyleLineBordercolorBoldInvert: '#4f5254',
        BMStyleOverlaysScrim: '#0b0b0b99',
        BMStyleLineBordercolorFocus: '#8be200',
        BMStyleLineBordercolorActive: '#0a9af2',
        BMStyleLineBordercolorError: '#ff4581',
        BMStyleLineBordercolorWarning: '#ffc629',
        BMStyleLineBorderStroke: 1,
        BMStyleLineBorderFocus: 3,
        BMStyleIconStroke: 1.5,
        BMStyleIconInkPrimary: '#242628',
        BMStyleIconInkPrimaryInvert: '#f0f1f2',
        BMStyleIconInkSecondary: '#707577',
        BMStyleIconInkAction: '#0071ce',
        BMStyleIconInkAccent: '#baf075',
        BMStyleImageSizeSmall: 32,
        BMStyleImageSizeMedium: 48,
        BMStyleImageSizeLarge: 64,
        BMStyleCardRadiusSpacious: 20,
        BMStyleCardRadiusCompact: 10,
        BMStyleCardRadiusNone: 0,
        BMStyleCardBordercolor: '#f0f1f2',
        BMStyleCardBgcolor: '#ffffff',
        BMStyleIconInkHighlightGreen: '#029d24',
        BMStyleTextInkHighlightRed: '#d32d55',
        BMStyleIconInkHighlightRed: '#d32d55',
        BMStyleTextInkHighlightYellow: '#d19e05',
        BMStyleIconInkHighlightYellow: '#ffc629',
        BMStyleTextInkMuted: '#a2a6a8',
        BMStyleIconInkMuted: '#a2a6a8',
        BMUiIndicatorStepperBgcolorCurrent: '#0071ce',
        BMUiIndicatorStepperBgcolorCurrentInverted: '#0a9af2',
        BMUiIndicatorStepperBgcolorNext: '#f0f1f2',
        BMUiIndicatorStepperBgcolorNextInverted: '#c1c4c6',
        BMUiBadgeBgcolorNew: '#8be200',
        BMUiBadgeInkNew: '#0a5c2c',
        BMUiBadgeBgcolorGreen: '#ddfeb4',
        BMUiBadgeInkGreen: '#0a5c2c',
        BMUiBadgeBgcolorBlue: '#d1f0ff',
        BMUiBadgeInkBlue: '#024590',
        BMUiBadgeBgcolorRed: '#ffded6',
        BMUiBadgeInkRed: '#8b1842',
        BMUiBadgeBgcolorYellow: '#fff1ce',
        BMUiBadgeInkYellow: '#732b06',
        BMUiBadgeBgcolorGrey: '#f0f1f2',
        BMUiBadgeInkGrey: '#4f5254',
        BMUiButtonBgcolorPrimary: '#0a9af2',
        BMUiButtonBgcolorPrimaryHovertap: '#0071ce',
        BMUiButtonBgcolorSecondary: '#d1f0ff',
        BMUiButtonBgcolorSecondaryHovertap: '#91d6fd',
        BMUiButtonBgcolorSecondaryOndark: '#024590',
        BMUiButtonBgcolorSecondaryOndarkHovertap: '#05285d',
        BMUiButtonBgcolorPay: '#fd5d1c',
        BMUiButtonBgcolorPayHoverTap: '#d33e09',
        BMUiButtonBgcolorDisabled: '#f0f1f2',
        BMUiButtonBgcolorMaster: '#a2a6a8',
        BMUiButtonBgcolorSwipeHighlight: '#8be200',
        BMUiButtonInkPrimary: '#ffffff',
        BMUiButtonInkSecondary: '#024590',
        BMUiButtonInkSecondaryOndark: '#d1f0ff',
        BMUiButtonInkPay: '#ffffff',
        BMUiButtonInkDisabled: '#a2a6a8',
        BMUiIndicatorVerticalStepperArtBgcolorNeutral: '#ffffff',
        BMUiIndicatorVerticalStepperTitleInkNeutral: '#242628',
        BMUiIndicatorVerticalStepperTitleInkGreen: '#029d24',
        BMUiIndicatorVerticalStepperTitleInkRed: '#d32d55',
        BMUiIndicatorVerticalStepperTitleInkYellow: '#d19e05',
        BMUiIndicatorVerticalStepperTitleInkBlue: '#0071ce',
        BMUiBadgeRadius: 4,
        BMUiBannerRadius: 10,
        BMUiBannerBgcolorGrey: '#f0f1f2',
        BMUiBannerBgcolorYellow: '#fff1ce',
        BMUiBannerBgcolorGreen: '#ddfeb4',
        BMUiBannerBgcolorRed: '#ffded6',
        BMUiBannerBgcolorBlue: '#d1f0ff',
        BMUiBannerBgcolorContrast: '#05285d',
        BMUiBannerTitleInkGrey: '#4f5254',
        BMUiBannerTitleInkYellow: '#732b06',
        BMUiBannerTitleInkGreen: '#0a5c2c',
        BMUiBannerTitleInkRed: '#8b1842',
        BMUiBannerTitleInkBlue: '#024590',
        BMUiBannerTitleInkContrast: '#f0f1f2',
        BMUiBannerMessageInkGrey: '#242628',
        BMUiBannerMessageInkYellow: '#371406',
        BMUiBannerMessageInkGreen: '#062814',
        BMUiBannerMessageInkRed: '#3e0923',
        BMUiBannerMessageInkBlue: '#05285d',
        BMUiBannerMessageInkContrast: '#f0f1f2',
        BMUiBadgeVMargin: 4,
        BMUiButtonTimerTrackBgcolor: '#029d24',
        BMUiBtngroupRadius: 999,
        BMUiBtngroupBgColorInactive: '#f5fbff',
        BMUiBtngroupBgColorSelected: '#d1f0ff',
        BMUiBtngroupInkInactive: '#024590',
        BMUiBtngroupInkSelected: '#0071ce',
        BMUiButtonInkMaster: '#707577',
        BMUiButtonTimerProgressBgcolor: '#8be200',
        BMUiButtonRadius: 999,
        BMUiButtonHeightLarge: 48,
        BMUiButtonHeightNormal: 32,
        BMUiButtonHeightInset: 24,
        BMUiButtonHmarginLarge: 16,
        BMUiButtonHmarginNormal: 12,
        BMUiButtonHmarginSmall: 8,
        BMUiCalloutRadius: 10,
        BMUiCalendarDatecellSelectedRadius: 999,
        BMUiControlBgcolorRadioCheckboxSurfaceBg: '#d1f0ff',
        BMUiControlBgcolorRadioCheckboxSurfaceBgActive: '#ddfeb4',
        BMUiControlBgcolorRadioCheckboxAccentBg: '#fafcff',
        BMUiControlBgcolorRadioCheckboxDisabled: '#f0f1f2',
        BMUiControlBgcolorRadioKnobSurfaceBg: '#ffffff',
        BMUiControlBgcolorRadioKnobKnobBg: '#8be200',
        BMUiControlBgcolorRadioKnobDisabled: '#ffffff',
        BMUiControlBgcolorRadioKnobError: '#fa9eb4',
        BMUiControlBgcolorToggleSurfaceBg: '#ffffff',
        BMUiControlBgcolorToggleRailsbgActive: '#0a9af2',
        BMUiControlBgcolorToggleRailsbgActivedisabled: '#91d6fd',
        BMUiControlBgcolorToggleRailsbgInactive: '#a2a6a8',
        BMUiControlBgcolorToggleRailsbgDisabled: '#f0f1f2',
        BMUiControlBgcolorSliderSliderValuebg: '#8be200',
        BMUiControlBgcolorSliderSliderValuedisabled: '#c1c4c6',
        BMUiControlBgcolorSliderSliderMarkerInvert: '#0a5c2c',
        BMUiControlBgcolorSliderSliderRailsbg: '#c1c4c6',
        BMUiControlBgcolorSliderSliderRailsdisabled: '#f0f1f2',
        BMUiControlBgcolorSliderSliderMarker: '#f0f1f2',
        BMUiControlBgcolorSliderKnobSurfacebg: '#ffffff',
        BMUiControlBgcolorSliderKnobSurfacedisabled: '#f0f1f2',
        BMUiControlBgcolorSliderKnobSurface: '#f0f1f2',
        BMUiControlBgcolorGroupError: '#fef5fc',
        BMUiControlBordercolorSliderKnob: '#f0f1f2',
        BMUiControlBordercolorRadioCheckboxLineOn: '#0071ce',
        BMUiControlBordercolorRadioCheckboxLineOff: '#0a9af2',
        BMUiControlBordercolorRadioKnobLine: '#029d24',
        BMUiControlBordercolorRadioKnobDisabled: '#c1c4c6',
        BMUiCalendarDatecellHeight: 72,
        BMUiCalendarBgcolorPrimary: '#ffffff',
        BMUiCalendarBgcolorToday: '#f5fbff',
        BMUiCalendarBgcolorBadgeLegend: '#f5fbff',
        BMUiCalendarBgcolorSelected: '#baf075',
        BMUiCalendarInkDatePrimary: '#05285d',
        BMUiCalendarInkDateDisabled: '#a2a6a8',
        BMUiCalendarInkDateSelected: '#0071ce',
        BMUiCalendarInkDateWeekend: '#0a9af2',
        BMUiCalendarInkHoliday: '#d32d55',
        BMUiCalendarBordercolorSelected: '#8be200',
        BMUiCalloutBgcolorGrey: '#ffffff',
        BMUiCalloutBgcolorYellow: '#fef9dc',
        BMUiCalloutBgcolorGreen: '#f7fcde',
        BMUiCalloutBgcolorRed: '#fef5fc',
        BMUiCalloutBgcolorBlue: '#f5fbff',
        BMUiCalloutBgcolorContrast: '#05285d',
        BMUiCalloutBgcolorGreyOverlayTransparent: '#ffffff00',
        BMUiCalloutBgcolorYellowOverlayTransparent: '#fef9dc00',
        BMUiCalloutBgcolorGreenOverlayTransparent: '#f7fcde00',
        BMUiCalloutBgcolorRedOverlayTransparent: '#fef5fc00',
        BMUiCalloutBgcolorBlueOverlayTransparent: '#f5fbff00',
        BMUiCalloutBgcolorContrastOverlayTransparent: '#05285d00',
        BMUiCalloutTitleInkGrey: '#4f5254',
        BMUiCalloutTitleInkYellow: '#732b06',
        BMUiCalloutTitleInkGreen: '#0a5c2c',
        BMUiCalloutTitleInkRed: '#8b1842',
        BMUiCalloutTitleInkBlue: '#024590',
        BMUiCalloutMessageInkGrey: '#242628',
        BMUiCalloutMessageInkYellow: '#371406',
        BMUiCalloutMessageInkGreen: '#062814',
        BMUiCalloutMessageInkRed: '#3e0923',
        BMUiCalloutMessageInkBlue: '#05285d',
        BMUiCalloutMessageInkContrast: '#f0f1f2',
        BMUiCalloutAnchorBgcolorGrey: '#c1c4c6',
        BMUiCalloutAnchorBgcolorYellow: '#ffcf9d',
        BMUiCalloutAnchorBgcolorGreen: '#baf075',
        BMUiCalloutAnchorBgcolorRed: '#fa9eb4',
        BMUiCalloutAnchorBgcolorBlue: '#91d6fd',
        BMUiIndicatorVerticalStepperArtBgcolorGreen: '#f7fcde',
        BMUiIndicatorVerticalStepperArtBgcolorRed: '#fef5fc',
        BMUiIndicatorVerticalStepperArtBgcolorYellow: '#fff1ce',
        BMUiIndicatorVerticalStepperArtBgcolorBlue: '#d1f0ff',
        BMUiIndicatorVerticalStepperContentInkNeutral: '#242628',
        BMUiIndicatorVerticalStepperContentInkGreen: '#0a5c2c',
        BMUiIndicatorVerticalStepperContentInkRed: '#8b1842',
        BMUiIndicatorVerticalStepperContentInkYellow: '#732b06',
        BMUiIndicatorVerticalStepperContentInkBlue: '#024590',
        BMUiIndicatorStepperBgcolorDone: '#0a5c2c',
        BMUiIndicatorStepperBgcolorDoneInverted: '#ddfeb4',
        BMUiIndicatorStepperInkDone: '#8be200',
        BMUiIndicatorStepperInkDoneInverted: '#f7fcde',
        BMUiIndicatorLoaderProgressBgcolor: '#0a9af2',
        BMUiIndicatorLoaderProgressBgcolorGreen: '#8be200',
        BMUiIndicatorLoaderProgressBgcolorNeutral: '#a2a6a8',
        BMUiIndicatorLoaderRailsBgcolor: '#f0f1f2',
        BMUiIndicatorLoaderRadius: 999,
        BMUiInputRadius: 10,
        BMUiPaginationBgcolor: '#baf075',
        BMUiInputBordercolor: '#c1c4c6',
        BMUiInputBgcolor: '#ffffff',
        BMUiInputInkPlaceholder: '#a2a6a8',
        BMUiInputInkError: '#d32d55',
        BMUiInputBgcolorDisabled: '#f0f1f2',
        BMUiPaginationInkcolor: '#024590',
        BMUiPaginationGradientTransparent: '#ffffff00',
        BMUiPaginationGradientEnd: '#ffffff',
        BMUiSpacerBgColor: '#ffded6',
        BMUiTabBordercolorActive: '#8be200',
        BMUiTabBordercolorInactive: '#baf075',
        BMUiTabIconInkActive: '#242628',
        BMUiSpacerLabelInk: '#d32d55',
        BMUiCalendarCalendarBadgeRadius: 10,
        BMUiIndicatorVerticalStepperLineNeutral: '#a2a6a8',
        BMUiIndicatorVerticalStepperLineGreen: '#0a5c2c',
        BMUiIndicatorVerticalStepperLineRed: '#8b1842',
        BMUiIndicatorVerticalStepperLineYellow: '#732b06',
        BMUiIndicatorVerticalStepperLineBlue: '#024590',
        BMUiIndicatorVerticalStepperArtBgcolorNeutralFill: '#0b0b0b',
        BMUiIndicatorVerticalStepperArtBgcolorGreenFill: '#0a5c2c',
        BMUiIndicatorVerticalStepperArtBgcolorRedFill: '#8b1842',
        BMUiIndicatorVerticalStepperArtBgcolorYellowFill: '#732b06',
        BMUiIndicatorVerticalStepperArtBgcolorBlueFill: '#024590',
        BMUiInputTimepickerElementBg: '#ffffff',
        BMUiInputTimepickerElementBgGradient: '#ffffffbf',
    },
    dark: {
        BMStyleTextInkPrimary: '#f0f1f2',
        BMStyleTextInkPrimaryInvert: '#242628',
        BMStyleTextInkSecondary: '#a2a6a8',
        BMStyleTextInkSecondaryInvert: '#707577',
        BMStyleTextInkSecondaryOncolorbg: '#ffffff99',
        BMStyleTextInkSecondaryOncolorbgInvert: '#0b0b0b99',
        BMStyleTextInkAction: '#0a9af2',
        BMStyleTextInkPrice: '#fd5d1c',
        BMStyleTextInkHighlight: '#8be200',
        BMStyleSurfaceBgcolor: '#0b0b0b',
        BMStyleSurfaceBgcolorInventory: '#05285d',
        BMStyleSurfaceBgcolorHero: '#0a9af2',
        BMStyleSurfaceBgcolorHighlight: '#0a5c2c',
        BMStyleSurfaceBgcolorActive: '#024590',
        BMStyleSurfaceBgcolorInvert: '#ffffff',
        BMStyleSurfaceBgcolorWarning: '#d33e09',
        BMStyleSurfaceBgcolorError: '#d32d55',
        BMStyleSurfaceBgcolorDisabled: '#4f5254',
        BMStyleLineBordercolorSubtle: '#242628',
        BMStyleLineBordercolorBold: '#4f5254',
        BMStyleLineBordercolorSubtleInvert: '#f0f1f2',
        BMStyleLineBordercolorBoldInvert: '#c1c4c6',
        BMStyleOverlaysScrim: '#0b0b0b99',
        BMStyleLineBordercolorFocus: '#8be200',
        BMStyleLineBordercolorActive: '#0071ce',
        BMStyleLineBordercolorError: '#d32d55',
        BMStyleLineBordercolorWarning: '#d19e05',
        BMStyleLineBorderStroke: 1,
        BMStyleLineBorderFocus: 3,
        BMStyleIconStroke: 1.5,
        BMStyleIconInkPrimary: '#f0f1f2',
        BMStyleIconInkPrimaryInvert: '#242628',
        BMStyleIconInkSecondary: '#a2a6a8',
        BMStyleIconInkAction: '#0a9af2',
        BMStyleIconInkAccent: '#062814',
        BMStyleImageSizeSmall: 32,
        BMStyleImageSizeMedium: 48,
        BMStyleImageSizeLarge: 64,
        BMStyleCardRadiusSpacious: 20,
        BMStyleCardRadiusCompact: 10,
        BMStyleCardRadiusNone: 0,
        BMStyleCardBordercolor: '#242628',
        BMStyleCardBgcolor: '#0b0b0b',
        BMStyleIconInkHighlightGreen: '#8be200',
        BMStyleTextInkHighlightRed: '#fa9eb4',
        BMStyleIconInkHighlightRed: '#fa9eb4',
        BMStyleTextInkHighlightYellow: '#ffcf9d',
        BMStyleIconInkHighlightYellow: '#ffcf9d',
        BMStyleTextInkMuted: '#707577',
        BMStyleIconInkMuted: '#707577',
        BMUiIndicatorStepperBgcolorCurrent: '#91d6fd',
        BMUiIndicatorStepperBgcolorCurrentInverted: '#f5fbff',
        BMUiIndicatorStepperBgcolorNext: '#4f5254',
        BMUiIndicatorStepperBgcolorNextInverted: '#a2a6a8',
        BMUiBadgeBgcolorNew: '#062814',
        BMUiBadgeInkNew: '#8be200',
        BMUiBadgeBgcolorGreen: '#0a5c2c',
        BMUiBadgeInkGreen: '#ddfeb4',
        BMUiBadgeBgcolorBlue: '#024590',
        BMUiBadgeInkBlue: '#d1f0ff',
        BMUiBadgeBgcolorRed: '#8b1842',
        BMUiBadgeInkRed: '#ffded6',
        BMUiBadgeBgcolorYellow: '#732b06',
        BMUiBadgeInkYellow: '#fff1ce',
        BMUiBadgeBgcolorGrey: '#4f5254',
        BMUiBadgeInkGrey: '#f0f1f2',
        BMUiButtonBgcolorPrimary: '#0071ce',
        BMUiButtonBgcolorPrimaryHovertap: '#024590',
        BMUiButtonBgcolorSecondary: '#024590',
        BMUiButtonBgcolorSecondaryHovertap: '#05285d',
        BMUiButtonBgcolorSecondaryOndark: '#d1f0ff',
        BMUiButtonBgcolorSecondaryOndarkHovertap: '#91d6fd',
        BMUiButtonBgcolorPay: '#d33e09',
        BMUiButtonBgcolorPayHoverTap: '#732b06',
        BMUiButtonBgcolorDisabled: '#4f5254',
        BMUiButtonBgcolorMaster: '#ffffff',
        BMUiButtonBgcolorSwipeHighlight: '#029d24',
        BMUiButtonInkPrimary: '#f5fbff',
        BMUiButtonInkSecondary: '#d1f0ff',
        BMUiButtonInkSecondaryOndark: '#024590',
        BMUiButtonInkPay: '#fef9dc',
        BMUiButtonInkDisabled: '#707577',
        BMUiIndicatorVerticalStepperArtBgcolorNeutral: '#0b0b0b',
        BMUiIndicatorVerticalStepperTitleInkNeutral: '#f0f1f2',
        BMUiIndicatorVerticalStepperTitleInkGreen: '#8be200',
        BMUiIndicatorVerticalStepperTitleInkRed: '#ff4581',
        BMUiIndicatorVerticalStepperTitleInkYellow: '#ffc629',
        BMUiIndicatorVerticalStepperTitleInkBlue: '#0a9af2',
        BMUiBadgeRadius: 4,
        BMUiBannerRadius: 10,
        BMUiBannerBgcolorGrey: '#4f5254',
        BMUiBannerBgcolorYellow: '#732b06',
        BMUiBannerBgcolorGreen: '#0a5c2c',
        BMUiBannerBgcolorRed: '#8b1842',
        BMUiBannerBgcolorBlue: '#024590',
        BMUiBannerBgcolorContrast: '#f5fbff',
        BMUiBannerTitleInkGrey: '#f0f1f2',
        BMUiBannerTitleInkYellow: '#fff1ce',
        BMUiBannerTitleInkGreen: '#ddfeb4',
        BMUiBannerTitleInkRed: '#ffded6',
        BMUiBannerTitleInkBlue: '#d1f0ff',
        BMUiBannerTitleInkContrast: '#242628',
        BMUiBannerMessageInkGrey: '#ffffff',
        BMUiBannerMessageInkYellow: '#fef9dc',
        BMUiBannerMessageInkGreen: '#f7fcde',
        BMUiBannerMessageInkRed: '#fef5fc',
        BMUiBannerMessageInkBlue: '#f5fbff',
        BMUiBannerMessageInkContrast: '#242628',
        BMUiBadgeVMargin: 4,
        BMUiButtonTimerTrackBgcolor: '#029d24',
        BMUiBtngroupRadius: 999,
        BMUiBtngroupBgColorInactive: '#05285d',
        BMUiBtngroupBgColorSelected: '#024590',
        BMUiBtngroupInkInactive: '#fafcff',
        BMUiBtngroupInkSelected: '#91d6fd',
        BMUiButtonInkMaster: '#ffffff',
        BMUiButtonTimerProgressBgcolor: '#8be200',
        BMUiButtonRadius: 999,
        BMUiButtonHeightLarge: 48,
        BMUiButtonHeightNormal: 32,
        BMUiButtonHeightInset: 24,
        BMUiButtonHmarginLarge: 16,
        BMUiButtonHmarginNormal: 12,
        BMUiButtonHmarginSmall: 8,
        BMUiCalloutRadius: 10,
        BMUiCalendarDatecellSelectedRadius: 999,
        BMUiControlBgcolorRadioCheckboxSurfaceBg: '#05285d',
        BMUiControlBgcolorRadioCheckboxSurfaceBgActive: '#0a5c2c',
        BMUiControlBgcolorRadioCheckboxAccentBg: '#ffffff',
        BMUiControlBgcolorRadioCheckboxDisabled: '#707577',
        BMUiControlBgcolorRadioKnobSurfaceBg: '#f0f1f2',
        BMUiControlBgcolorRadioKnobKnobBg: '#029d24',
        BMUiControlBgcolorRadioKnobDisabled: '#707577',
        BMUiControlBgcolorRadioKnobError: '#ff4581',
        BMUiControlBgcolorToggleSurfaceBg: '#f0f1f2',
        BMUiControlBgcolorToggleRailsbgActive: '#0071ce',
        BMUiControlBgcolorToggleRailsbgActivedisabled: '#024590',
        BMUiControlBgcolorToggleRailsbgInactive: '#c1c4c6',
        BMUiControlBgcolorToggleRailsbgDisabled: '#4f5254',
        BMUiControlBgcolorSliderSliderValuebg: '#029d24',
        BMUiControlBgcolorSliderSliderValuedisabled: '#707577',
        BMUiControlBgcolorSliderSliderMarkerInvert: '#8be200',
        BMUiControlBgcolorSliderSliderRailsbg: '#707577',
        BMUiControlBgcolorSliderSliderRailsdisabled: '#707577',
        BMUiControlBgcolorSliderSliderMarker: '#a2a6a8',
        BMUiControlBgcolorSliderKnobSurfacebg: '#f0f1f2',
        BMUiControlBgcolorSliderKnobSurfacedisabled: '#707577',
        BMUiControlBgcolorSliderKnobSurface: '#c1c4c6',
        BMUiControlBgcolorGroupError: '#8b1842',
        BMUiControlBordercolorSliderKnob: '#a2a6a8',
        BMUiControlBordercolorRadioCheckboxLineOn: '#0a9af2',
        BMUiControlBordercolorRadioCheckboxLineOff: '#0a9af2',
        BMUiControlBordercolorRadioKnobLine: '#8be200',
        BMUiControlBordercolorRadioKnobDisabled: '#a2a6a8',
        BMUiCalendarDatecellHeight: 72,
        BMUiCalendarBgcolorPrimary: '#242628',
        BMUiCalendarBgcolorToday: '#05285d',
        BMUiCalendarBgcolorBadgeLegend: '#0e1014',
        BMUiCalendarBgcolorSelected: '#029d24',
        BMUiCalendarInkDatePrimary: '#d1f0ff',
        BMUiCalendarInkDateDisabled: '#707577',
        BMUiCalendarInkDateSelected: '#f5fbff',
        BMUiCalendarInkDateWeekend: '#d1f0ff',
        BMUiCalendarInkHoliday: '#fa9eb4',
        BMUiCalendarBordercolorSelected: '#baf075',
        BMUiCalloutBgcolorGrey: '#242628',
        BMUiCalloutBgcolorYellow: '#371406',
        BMUiCalloutBgcolorGreen: '#062814',
        BMUiCalloutBgcolorRed: '#3e0923',
        BMUiCalloutBgcolorBlue: '#05285d',
        BMUiCalloutBgcolorContrast: '#f5fbff',
        BMUiCalloutBgcolorGreyOverlayTransparent: '#24262800',
        BMUiCalloutBgcolorYellowOverlayTransparent: '#37140600',
        BMUiCalloutBgcolorGreenOverlayTransparent: '#06281400',
        BMUiCalloutBgcolorRedOverlayTransparent: '#3e092300',
        BMUiCalloutBgcolorBlueOverlayTransparent: '#05285d00',
        BMUiCalloutBgcolorContrastOverlayTransparent: '#f5fbff00',
        BMUiCalloutTitleInkGrey: '#f0f1f2',
        BMUiCalloutTitleInkYellow: '#fff1ce',
        BMUiCalloutTitleInkGreen: '#ddfeb4',
        BMUiCalloutTitleInkRed: '#ffded6',
        BMUiCalloutTitleInkBlue: '#d1f0ff',
        BMUiCalloutMessageInkGrey: '#ffffff',
        BMUiCalloutMessageInkYellow: '#ffffff',
        BMUiCalloutMessageInkGreen: '#ffffff',
        BMUiCalloutMessageInkRed: '#ffffff',
        BMUiCalloutMessageInkBlue: '#f5fbff',
        BMUiCalloutMessageInkContrast: '#242628',
        BMUiCalloutAnchorBgcolorGrey: '#707577',
        BMUiCalloutAnchorBgcolorYellow: '#d33e09',
        BMUiCalloutAnchorBgcolorGreen: '#029d24',
        BMUiCalloutAnchorBgcolorRed: '#d32d55',
        BMUiCalloutAnchorBgcolorBlue: '#0071ce',
        BMUiIndicatorVerticalStepperArtBgcolorGreen: '#0a5c2c',
        BMUiIndicatorVerticalStepperArtBgcolorRed: '#8b1842',
        BMUiIndicatorVerticalStepperArtBgcolorYellow: '#732b06',
        BMUiIndicatorVerticalStepperArtBgcolorBlue: '#024590',
        BMUiIndicatorVerticalStepperContentInkNeutral: '#f0f1f2',
        BMUiIndicatorVerticalStepperContentInkGreen: '#ddfeb4',
        BMUiIndicatorVerticalStepperContentInkRed: '#ffded6',
        BMUiIndicatorVerticalStepperContentInkYellow: '#fff1ce',
        BMUiIndicatorVerticalStepperContentInkBlue: '#d1f0ff',
        BMUiIndicatorStepperBgcolorDone: '#baf075',
        BMUiIndicatorStepperBgcolorDoneInverted: '#ddfeb4',
        BMUiIndicatorStepperInkDone: '#ddfeb4',
        BMUiIndicatorStepperInkDoneInverted: '#f7fcde',
        BMUiIndicatorLoaderProgressBgcolor: '#91d6fd',
        BMUiIndicatorLoaderProgressBgcolorGreen: '#baf075',
        BMUiIndicatorLoaderProgressBgcolorNeutral: '#c1c4c6',
        BMUiIndicatorLoaderRailsBgcolor: '#4f5254',
        BMUiIndicatorLoaderRadius: 999,
        BMUiInputRadius: 10,
        BMUiPaginationBgcolor: '#8be200',
        BMUiInputBordercolor: '#4f5254',
        BMUiInputBgcolor: '#0b0b0b',
        BMUiInputInkPlaceholder: '#707577',
        BMUiInputInkError: '#fa9eb4',
        BMUiInputBgcolorDisabled: '#a2a6a8',
        BMUiPaginationInkcolor: '#0071ce',
        BMUiPaginationGradientTransparent: '#0b0b0b00',
        BMUiPaginationGradientEnd: '#0b0b0b',
        BMUiSpacerBgColor: '#fa9eb4',
        BMUiTabBordercolorActive: '#029d24',
        BMUiTabBordercolorInactive: '#062814',
        BMUiTabIconInkActive: '#f0f1f2',
        BMUiSpacerLabelInk: '#8b1842',
        BMUiCalendarCalendarBadgeRadius: 10,
        BMUiIndicatorVerticalStepperLineNeutral: '#c1c4c6',
        BMUiIndicatorVerticalStepperLineGreen: '#ddfeb4',
        BMUiIndicatorVerticalStepperLineRed: '#ffded6',
        BMUiIndicatorVerticalStepperLineYellow: '#fff1ce',
        BMUiIndicatorVerticalStepperLineBlue: '#d1f0ff',
        BMUiIndicatorVerticalStepperArtBgcolorNeutralFill: '#ffffff',
        BMUiIndicatorVerticalStepperArtBgcolorGreenFill: '#ddfeb4',
        BMUiIndicatorVerticalStepperArtBgcolorRedFill: '#fef5fc',
        BMUiIndicatorVerticalStepperArtBgcolorYellowFill: '#fff1ce',
        BMUiIndicatorVerticalStepperArtBgcolorBlueFill: '#d1f0ff',
        BMUiInputTimepickerElementBg: '#0b0b0b',
        BMUiInputTimepickerElementBgGradient: '#0b0b0b80',
    },
};
export const BMAnimation = {
    duration: {
        instant: 100,
        quick: 200,
        moderate: 400,
        extended: 600,
    },
    transition: {
        easeInOut: {
            x1: 0.42,
            y1: 0,
            x2: 0.58,
            y2: 1,
        },
        easeOut: {
            x1: 0,
            y1: 0,
            x2: 0.58,
            y2: 1,
        },
        easeOutBounce: {
            x1: 0.12,
            y1: 0.4,
            x2: 0.28,
            y2: 1.36,
        },
        easeInBounce: {
            x1: 0.7,
            y1: -0.4,
            x2: 0.8,
            y2: 0.6,
        },
        spring: {
            x1: 0.42,
            y1: 0,
            x2: 0.58,
            y2: 0.1,
        },
        linear: {
            x1: 0,
            y1: 0,
            x2: 1,
            y2: 1,
        },
    },
};
export const BMElevation = {
    light: {
        elevation1: {
            outline: '#c1c4c6',
            shadow: null,
        },
        elevation2: {
            outline: null,
            shadow: {
                color: '#0b0b0b',
                opacity: 10,
                offset: {
                    x: 0,
                    y: 2,
                },
                blur: 24,
                spread: -4,
            },
        },
    },
    dark: {
        elevation1: {
            outline: '#4f5254',
            shadow: null,
        },
        elevation2: {
            outline: null,
            shadow: {
                color: '#0b0b0b',
                opacity: 10,
                offset: {
                    x: 0,
                    y: 2,
                },
                blur: 24,
                spread: -4,
            },
        },
    },
};
